var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContactContext } from "@/contexts/contact";
import { useCustomerAction } from "@/hooks";
import { useI18n } from "@/shared/hooks";
import { useIsPreviewMode } from "@/shared/hooks/useIsPreviewMode";
import { Box } from "@gemini/core";
import { Button } from "@gemini/ui";
import { useFormContext } from "react-hook-form";
export const testId = "cdp-sections-units-unit-buttons";
export const UnitButtons = (_a) => {
    var unit = __rest(_a, []);
    const isPreviewMode = useIsPreviewMode();
    const { customerActionExposeInteraction } = useCustomerAction();
    const { setValue } = useFormContext();
    const { toggleModal } = useContactContext();
    const { t } = useI18n();
    const trackCustomerActionLeadMailInterestView = () => __awaiter(void 0, void 0, void 0, function* () {
        return yield customerActionExposeInteraction([
            { key: "interaction", value: "openContactForm" },
        ]);
    });
    const handlePress = (av_zone) => {
        if (isPreviewMode)
            return;
        const newMessage = t("pdpSeeker_unitTable_askFloorPlanDefaultMessage");
        if (av_zone === "pdp_floor_plan") {
            setValue("message", newMessage);
        }
        trackCustomerActionLeadMailInterestView();
        toggleModal({
            av_zone,
            legacyTrackingInfos: av_zone,
            unitId: unit === null || unit === void 0 ? void 0 : unit.id,
        });
    };
    return (_jsxs(Box, { display: "flex", alignItems: "center", marginLeft: {
            "breakpoint.base": 0,
            "breakpoint.lg": "spacing.8",
        }, marginTop: {
            "breakpoint.base": "spacing.16",
            "breakpoint.lg": 0,
        }, testId: testId, children: [_jsx(Button, { size: "40", variant: "secondary", marginRight: "spacing.8", isFullWidth: {
                    "breakpoint.base": true,
                    "breakpoint.lg": false,
                }, onPress: () => handlePress("pdp_floor_plan"), children: t("pdpSeeker_unitTable_askFloorPlanButtonTitle_alt") }), _jsx(Button, { size: "40", isFullWidth: {
                    "breakpoint.base": true,
                    "breakpoint.lg": false,
                }, onPress: () => handlePress("pdp_contact_entry_unit"), children: t("pdpSeeker_unitTable_contactButtonTitle") })] }));
};
